import { APIClient } from "./apiCore";
import * as url from "./urls";

const api = new APIClient();


// 차량번호 조회
export const postDcSelUserVeh = (data) =>
    api.create(url.POST_DC_SEL_USER_VEH, data);
// 사용자 차량번호 저장
export const postDcUpdUserVeh = (data) =>
    api.create(url.POST_DC_UPD_USER_VEH, data);
// 일상 점검 기준 항목 코드 리스트 조회
export const postDcDailyCheckItemCdList = (data) =>
    api.create(url.POST_DC_DAILY_CHECK_ITEM_CD_LIST, data);
// 일상 점검 저장
export const postDcInsDailyCheck = (data) =>
    api.create(url.POST_DC_INS_DAILY_CHECK, data);
// 상세 조회
export const postDcSelDailyCheckDetail = (data) =>
    api.create(url.POST_DC_SEL_DAILY_CHECK_DETAIL, data);
// 삭제
export const postDcDelDailyCheck = (data) =>
    api.create(url.POST_DC_DEL_DAILY_CHECK, data);
// 특정 달(Month)의 월별 점검 리스트 현황 조회
export const postDcSelDCListByMonth = (data) =>
    api.create(url.POST_DC_SEL_DC_LIST_BY_MONTH, data);
// 블록체인 데이터 조회
export const postDcSelDCBCDate = (data) =>
    api.create(url.POST_DC_SEL_DC_BC_DATA, data);
